var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e2e-gfx-board"},[_c('div',{staticClass:"mc-gfx-board",attrs:{"id":_vm.idOfDomTarget}})])}]

export { render, staticRenderFns }